const en = {
  home: "Home",
  aboutUs: "About Us",
  products: "Products",
  research: "Research",
  infrastructure: "Infrastructure",
  network: "Network",
  store: "Store",
  careers: "Careers",
  reachUs: "Reach Us",
  dashboard: "Dashboard",
  cropBook: "Crop Book",
  search: "Search",
  blog: "Blog",
  cart: "Cart",
  login: "Login",
  privacyPolicy: "Privacy Policy",
  termOfUse: "Terms of use",
  disclaimer: "Disclaimer",
  cancellationAndRefund: "Cancellation and Refund",
  shippingAndDelivery: "Shipping and Delivery",
  //Menu Page
  OurProducts: "Our Products",
  OurProductsDescription: "Our range of research-backed, high-yield seeds are developed to meet the precise crop growth requirements of different agro-climatic zones across the country, thereby delivering the best results for farmers.",
  // Home Page
  ViewDetailsButton: "View Details",
  YashodaAtAGlanceHeading: "Yashoda At A Glance",
  ExploreCategoryButton: "Explore Category",
  KnowMoreButton: "Know More",
  BuyOnlineButton: "Buy Online",
  NetworkHead: "To view our entire network, please share your contact number",
  ExploreOurNetworkButton: "Explore our network",
  JobOpenings: "Job Openings",
  TeamStrength: "200+ Team Strength",
  TeamMembers: "50+ team members have been working with us for 10+ years",
  Experience: "Experience",
  ExploreOpportunities: "Explore opportunities",
  LifeYashoda: "Life @ Yashoda Seeds",
  FarmersConnectedHead: "Farmers Connected",
  FarmersConnectButton: "Farmers Connect",
  ExploreMoreButton: "Explore More",

  // About Page
  YearExperience: "Years Of <br />Experience",
  MissionVission: "Our Mission <br /> & Vision",
  ourHistory: "Our History",
  ChairmanDesk: "FROM THE CHAIRMAN’S DESK",
  //Network Page
  PartnerHead: "Our Partners",
  DealerHead: "Want to be our dealer?",
  DealerBtn: "Connect With Us ",
  //Form Field
  FormHead: "Have a Query? Get in Touch!",
  FirstName: "First Name",
  LastName: "Last Name",
  PhoneNo: "Phone No",
  Email: "Email",
  Message: "Message",
  SubmitButton: "Submit", 
  FullName: "Full Name",
  Address: "Address",
  City: "City",
  PinCode: "Pin Code",
  //Contact page
  Call: "Call Us",
  Mail: "Mail Us",
  loc: "Location",
  HaveEnquiries: "Have enquiries?",
  //Product
  Description: "Description",
  Specifications: "Specifications",
  EnquireNowButton: "Enquire Now", 
  ViewSpecificationsButton: "View Specifications",
  //Product Details Page
  MRP: "MRP",
  Weight: "Weight",
  Quantity: "Quantity",
  OutOfStock: "Out of Stock",
  Description: "Description",
  AddToCart: "Add to Cart",
  EnquiryNowButton: "Enquiry Now",
  RelatedProducts: "Related Products",
  OthersCategory: "Others Category",
  //Store Page
  Filters: "Filters",
  Category: "Category",
  LoadMore: "Load More",
  NoProductsFound: "No products found to show.",
  //Cart Page
  Cart: "Cart",
  Checkout: "Checkout",
  Payment: "Payment",
  Price: "Price",
  Total: "Total",
  Code: "Code",
  DeliveryCharges: "Delivery Charges",
  DeliveryChargesNote: "if the total amount is less than 700 then you have to pay the delivery charges",
  Subtotal: "Subtotal",
  ContinueShoppingButton: "Continue Shopping",
  CheckoutButton: "Checkout",
  YourCartIsEmpty: "Your cart is empty",
  //Checkout Page
  AddAddress: "Add Address",
  Close: "Close",
  PleaseLoginToCheckout: "Please Login to checkout.",
  LoginHere: "Login here",
  PayNow: "Pay now",
  OrderSummery: "Order Summery",
  Note: "Note",
  DoNotRefreshOrClose: "Do not refresh or close this page during an ongoing transaction. Doing so may result in duplicate charges or transaction failures.",
  AddYourAddressDetails: "Add Your Address Details",
  //Footer
  FeelFreeToCallUs: "Feel free to call us",
  OfficeLocation: "Office Location",
  DropUsAnEmail: "Drop us an email",
  ConnectWithUs: "Connect With Us",
  //Dashboard Page
  MyOrders: "My Orders",
  Wishlist: "Wishlist",
  MyAccount: "My Account",
  Logout: "Logout",
  ViewOrder: "View Order",
  ID: "ID",
  Date: "Date",
  Total: "Total",
  Status: "Status",
  ViewOrder: "View Order",
  DownloadInvoice: "Download Invoice",
  OrderReceived: "Order Received",
  OrderProcessing: "Order Processing",
  OrderDispatch: "Order Dispatch",
  OrderDeliver: "Order Deliver",
  Paymentprocessing: "Payment processing",
  Unknownstatus: "Unknown status",
  SlNo: "Sl No",
  Item: "Item",
  image: "Image",
  //logout  
  AreYouSure: "Are you sure?",
  Logout: "Logout!",
  Cancel: "Cancel",
  //SEO
  Best: "Best",
  BuyNowButton: "Buy Now",

};

export default en;